module.exports = __webpack_public_path__ + "img/gwc.1ebeb21a.png";